import { createContext } from 'react';
import type { Language, TranslationStrings } from './translations';

export interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  translations: TranslationStrings;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);